
/*****************************************
 api.js 自定义JS文件封装API接口
 本接口文件主要包含 post get 交互
 *****************************************/

import axios from 'axios'
import {Message} from 'element-ui';
import router from '../router'

axios.interceptors.response.use(success => {

    if (success.status && success.status == 200 && success.data.status == 500) {
        Message.error({message: success.data.msg})
        return;
    }
    if (success.data.msg) {
        Message.success({message: success.data.msg})
    }
    return success.data;
}, error => {

    if (error.response.status == 504 || error.response.status == 404) {
        Message.error({message: error.response.status + ' 未找到服务...'});
    }
    else if (error.response.status == 403) {
        Message.error({message: '权限不足，请联系管理员'});
    }
    else if (error.response.status == 401) {
        if(router.currentRoute.path!=='/') {
            Message.error({message: '尚未登录，请登录'});
            console.log('尚未登录，请登录');
            router.replace('/');
        }
    }
    else {

        if (error.response.data.msg) {
            Message.error({message: error.response.data.msg})
        }
        else {
            console.log(JSON.stringify(error.response));
            //Message.error({message: '未知错误!'})
            Message.error({message: JSON.stringify(error)})
        }
    }
    return;
})

// let base = '/pb-api/v2/';
let base = process.env.VUE_APP_BASE_API_PRE

export const postKeyValueRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let i in data) {
                ret += encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&'
            }
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}
export const postRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params
    })
}
export const putRequest = (url, params) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: params
    })
}
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        data: params
    })
}
export const deleteRequest = (url, params) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        data: params
    })
}
